const STORAGE_KEY = 'cookieBannerAccepted'
const banner = document.querySelector('.cookie-banner')

if (banner && localStorage.getItem(STORAGE_KEY) !== 'true') {
    banner.classList.remove('is-hidden')

    banner.querySelector('[data-cookie-accept]')?.addEventListener('click', () => {
        localStorage.setItem(STORAGE_KEY, 'true')
        banner.classList.add('is-hidden')
    })
}
